import Request from "../common/Request.jsx";

// ACA-35 (ADR-004): client beacons for the intents funnel. Posts to the
// dedicated POST /api/onboarding/intents/events endpoint. Fire-and-forget:
// analytics must never block the funnel or surface an error to the artist.

export type IntentEventName =
  | "intent_selected"
  | "intent_deselected"
  | "onboarding_submitted";

export interface IntentEventPayload {
  // Bitmask value of the toggled chip (intent_selected / intent_deselected).
  intent?: number;
  // Combined bitmask of all selected intents (onboarding_submitted).
  intents?: number;
  totalSelected?: number;
  entryPath: string;
  isArtistReferral: boolean;
}

function resolveIntentEventsUrl(): string {
  const resolved =
    typeof window !== "undefined" &&
    (
      window as unknown as {
        Artcloud?: {
          url?: {
            vendor?: {
              onboarding?: { intents?: { events?: { post?: () => string } } };
            };
          };
        };
      }
    ).Artcloud?.url?.vendor?.onboarding?.intents?.events?.post?.();
  return resolved || "/api/onboarding/intents/events";
}

export function emitIntentEvent(
  name: IntentEventName,
  payload: IntentEventPayload,
): void {
  // A rejected beacon promise must be caught here, otherwise it becomes an
  // unhandled rejection — the try/catch only guards the synchronous path.
  try {
    const pending = Request.post(resolveIntentEventsUrl(), {
      EventName: name,
      Intent: payload.intent,
      Intents: payload.intents,
      TotalSelected: payload.totalSelected,
      EntryPath: payload.entryPath,
      IsArtistReferral: payload.isArtistReferral,
    });
    if (pending && typeof pending.catch === "function") {
      pending.catch(() => {
        /* swallow — analytics is best-effort */
      });
    }
  } catch (_) {
    /* swallow synchronous failures */
  }
}
